import React from 'react';
import { observer } from 'mobx-react-lite';
import { List as MovableList } from 'react-movable';
import {
    SportsFiltersWrapper,
    FiltersWrapper,
    MovableItemWrapper,
    FiltersListWrapper,
} from './SportsFilters.style';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { SportsFilterItem } from './SportsFilterItem';
import { AddCompetition } from './AddCompetition';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { InputRow } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { ButtonOnInputSide } from 'src/domains/layouts/shared/buttons/Button.style';

interface PropsTypes {
    sportState: CustomizedSportsState,
}

export const SportsFilters = observer(({ sportState }: PropsTypes) => {
    const {
        handleAddFilter,
        handleFiltersOrder,
        filtersList,
        activeFilter,
        filterName
    } = sportState;

    return (
        <div>
            <InputRow>
                <Input
                    label='Filter name'
                    formInputState={filterName}
                    dataTest='custom-filter-input'
                />
                <ButtonOnInputSide version='primary' size='regular' onClick={handleAddFilter} data-test='custom-filter-add-button'>Add filter</ButtonOnInputSide>
            </InputRow>
            {filtersList.length > 0 ? (
                <>
                    <SportsFiltersWrapper>
                        <FiltersListWrapper>
                            <Label>Filters and added competitions</Label>
                            <MovableList
                                values={filtersList}
                                onChange={handleFiltersOrder}
                                renderList={({ children, props }): React.ReactNode => <FiltersWrapper {...props}>{children}</FiltersWrapper>}
                                renderItem={({ value, props, isDragged }): JSX.Element | null => {
                                    return (
                                        <MovableItemWrapper {...props}>
                                            <SportsFilterItem key={value.slug} slug={value.slug} isDragged={isDragged} sportState={sportState} dataTest='custom-filter-preview'/>
                                        </MovableItemWrapper>
                                    );
                                }}
                            />
                        </FiltersListWrapper>
                        {activeFilter !== null ? (
                            <AddCompetition sportState={sportState} />
                        ) : null}
                    </SportsFiltersWrapper>
                </>
            ) : null}
        </div>
    );
});
